import { DeploymentEnvironmentName } from "@src/appV2/environment";

export interface CognitoConfig {
  userPoolId: string;
  clientId: string;
}

export function getCognitoConfig(environmentName: DeploymentEnvironmentName): CognitoConfig {
  // FIXME: Automatically disabled during ESLint config update
  switch (environmentName) {
    case DeploymentEnvironmentName.STAGING: {
      return {
        userPoolId: "us-west-2_HV1ibP3I6",
        clientId: "1rdet93018ud96nj8coknf50l9",
      };
    }

    case DeploymentEnvironmentName.PROD_SHADOW: {
      return {
        userPoolId: "us-west-2_1tSFVnCSa",
        clientId: "18nsd90shtg1q56qp4v5j9huo1",
      };
    }

    case DeploymentEnvironmentName.PRODUCTION: {
      return {
        userPoolId: "us-west-2_in7ey5PCw",
        clientId: "5hq35aignj3t5l40vv3qpbb7g2",
      };
    }

    // Development environment by default
    default: {
      return {
        userPoolId: "us-west-2_N0koNIUOZ",
        clientId: "5rbpldo7e62knc0lq0audjvh9k",
      };
    }
  }
}

export const cognitoConfig = getCognitoConfig(
  process.env.REACT_APP_ENVIRONMENT_NAME as DeploymentEnvironmentName
);

export interface ImpersonationCognitoConfig {
  userPoolId: string;
  clientId: string;
}

/**
 * Returns the Cognito config for impersonation, which uses a different client ID
 * that has ALLOW_REFRESH_TOKEN_AUTH excluded.
 */
export function getImpersonationCognitoConfig(
  environmentName: DeploymentEnvironmentName
): ImpersonationCognitoConfig {
  const baseConfig = getCognitoConfig(environmentName);

  switch (environmentName) {
    case DeploymentEnvironmentName.STAGING: {
      return {
        userPoolId: baseConfig.userPoolId,
        clientId: "4hee1uscga3i97a6bj6hfd857l",
      };
    }

    case DeploymentEnvironmentName.PROD_SHADOW: {
      return {
        userPoolId: baseConfig.userPoolId,
        clientId: "3hj3c1piqgcairqaqc9894tjga",
      };
    }

    case DeploymentEnvironmentName.PRODUCTION: {
      return {
        userPoolId: baseConfig.userPoolId,
        clientId: "7os4col2mfahqucsgct0t5cskc",
      };
    }

    // Development environment by default
    default: {
      return {
        userPoolId: baseConfig.userPoolId,
        clientId: "5kun0fqq39pvsp8ob4onannidv",
      };
    }
  }
}

export const impersonationCognitoConfig = getImpersonationCognitoConfig(
  process.env.REACT_APP_ENVIRONMENT_NAME as DeploymentEnvironmentName
);
